import React, { Component, CSSProperties } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Tag, List, Icon, Popover, Button } from 'antd'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class TermsList extends Component<any, any> {
    render() {
        const {
            termsFilters,
            filteredTerms,
            indexedKeywords,
            addFilter,
            addPendingKeyword,
            pendingKeywords,
            removePendingKeyword
        } = this.props.synonymsStore
        return (
            <List
                dataSource={filteredTerms}
                pagination={{ pageSize: 7 }}
                renderItem={item => (
                    <List.Item
                        key={item['id']}
                        style={{ padding: '0.5rem 0', flexDirection: 'column', textAlign: 'right' }}
                    >
                        <div style={{ width: '100%' }}>
                            <strong>{item['name']}</strong>
                        </div>
                        <div style={{ width: '100%' }}>
                            {item['summary'].split(' ').map((keyword, index) => {
                                const pending = pendingKeywords.filter(item => keyword === item)
                                const trimedKeyword = keyword.replace('_', ' ')
                                if (
                                    !termsFilters['keywords'] ||
                                    (termsFilters['keywords'] === 'assigned' && indexedKeywords[keyword]) ||
                                    (termsFilters['keywords'] === 'unassigned' && !indexedKeywords[keyword]) ||
                                    (termsFilters['keywords'] === 'pending' && pending.length > 0)
                                ) {
                                    const style = { margin: '0.2rem 0 0.2rem 0.5rem', cursor: 'pointer' }
                                    let tag = (
                                        <Tag
                                            key={index}
                                            style={{ ...style }}
                                            onClick={() => addPendingKeyword(keyword)}
                                        >
                                            <span style={{ marginLeft: '0.1rem', fontSize: '0.9rem' }}>+</span>
                                            {trimedKeyword}
                                        </Tag>
                                    )
                                    if (indexedKeywords[keyword]) {
                                        tag = (
                                            <Tag
                                                key={index}
                                                style={{ ...style, backgroundColor: '#c7c7c7', opacity: 0.5 }}
                                                onClick={() => addFilter('freeSearch', trimedKeyword)}
                                            >
                                                <Icon type="search" /> {trimedKeyword}
                                            </Tag>
                                        )
                                    } else if (pending.length > 0) {
                                        tag = (
                                            <Tag
                                                key={index}
                                                style={{ ...style, backgroundColor: '#f7d199' }}
                                                onClick={() => removePendingKeyword(keyword)}
                                            >
                                                <Icon type="stop" /> {trimedKeyword}
                                            </Tag>
                                        )
                                    }
                                    return tag
                                }
                            })}
                        </div>
                    </List.Item>
                )}
            />
        )
    }
}

export default withRouter(TermsList)
